if (!customElements.get('bf-audio-compare')) {
  class BlackFridayAudioCompare extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;

      const rows = [...this.querySelectorAll('.bf-track')];
      const players = rows.map(row => row.querySelector('audio'));
      const selector = this.querySelector('fieldset');
      const choices = [...selector.querySelectorAll('input')];
      const status = this.querySelector('[role="status"]');
      if (players.length !== 2 || choices.length !== players.length) return;

      const events = new AbortController();
      const options = { signal: events.signal };
      let active = 0;
      let switchNumber = 0;
      let pending = false;
      let position = 0;
      let resume = false;

      const show = index => {
        rows.forEach((row, number) => { row.hidden = number !== index; });
        choices[index].checked = true;
      };

      choices.forEach((choice, index) => {
        choice.addEventListener('change', () => {
          if (!choice.checked || active === index) return;

          const oldPlayer = players[active];
          const nextPlayer = players[index];
          if (!pending) {
            position = oldPlayer.ended ? 0 : oldPlayer.currentTime;
            resume = !oldPlayer.paused && !oldPlayer.ended;
          }
          nextPlayer.volume = oldPlayer.volume;
          nextPlayer.muted = oldPlayer.muted;
          oldPlayer.pause();
          active = index;
          const sequence = ++switchNumber;
          show(index);
          status.textContent = '';

          const restore = () => {
            if (sequence !== switchNumber) return;
            pending = false;
            nextPlayer.currentTime = Math.min(position, nextPlayer.duration || position);
            if (resume) {
              nextPlayer.play().catch(() => {
                if (sequence === switchNumber) status.textContent = 'Press play to continue this version.';
              });
            }
          };

          if (position === 0 && !resume) {
            pending = false;
            if (nextPlayer.readyState >= 1) nextPlayer.currentTime = 0;
          } else if (nextPlayer.readyState >= 1) {
            restore();
          } else {
            pending = true;
            nextPlayer.addEventListener('loadedmetadata', restore, { ...options, once: true });
            nextPlayer.load();
          }
        }, options);
      });

      players.forEach((player, index) => {
        player.addEventListener('error', () => {
          if (index === active) {
            pending = false;
            status.textContent = 'This audio file could not be loaded. Try the other version or visit the product page.';
          }
        }, options);
      });

      show(0);
      selector.hidden = false;
      this.classList.add('bf-ab-ready');
      this.cleanup = () => {
        switchNumber++;
        events.abort();
        players.forEach(player => player.pause());
        rows.forEach(row => { row.hidden = false; });
        selector.hidden = true;
        this.classList.remove('bf-ab-ready');
      };
    }

    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
      this.cleanup = null;
    }
  }

  customElements.define('bf-audio-compare', BlackFridayAudioCompare);
}
